import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { media } from "@/i18n/translations";
import SEO from "@/components/SEO";
import { PageHeader } from "@/components/ui-primitives";
import NetworkMap from "@/components/NetworkMap";

const Destinations = () => {
  const { t, lang } = useLanguage();
  return (
    <>
      <SEO
        path="/destinations"
        title={lang === "ru" ? "Сеть яхтенного агентирования в Турции" : "Yacht Agency Network Across Türkiye"}
        description={
          lang === "ru"
            ? "Интерактивная карта покрытия Rota Yachting: Чёрное море, Мармара, Эгейское и Средиземное моря — 20 портов и марин."
            : "Interactive coverage map for Rota Yachting Agency: Black Sea, Marmara, Aegean and Mediterranean — 20 ports and marinas with full yacht agency services."
        }
        keywords="yacht agency Türkiye, yacht agent Turkey, yacht port services Turkey, superyacht agency Turkey, Black Sea yacht agency, Turkish marina support, yacht customs clearance Turkey, yacht provisioning Turkey, yacht concierge Turkey, Rota Yachting Agency"
      />
      <PageHeader
        eyebrow={t.destinationsPage.eyebrow}
        title={t.destinationsPage.title}
        intro={t.destinationsPage.intro}
        image="/assets/photos/destinations-hero.jpg"
        testId="destinations-header"
      />

      <NetworkMap />
    </>
  );
};

export default Destinations;
